
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static/module/[...slug]",
      function () {
        return require("private-next-pages/static/module/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static/module/[...slug]"])
      });
    }
  